import { Apk, ApkForm, ApkUpsert } from '@models/.';

export function transformToData(apk: Apk | null): Apk | null {
  if (!apk) return null;
  
  return {
    ...apk,
  };
}

export function transformToForm(apk?: Apk): ApkForm | undefined {
  if (!apk) return;
  
  return apk;
}

export function transformToUpsert(apkForm: ApkForm): ApkUpsert | undefined {
  if (!apkForm) return;
  
  return apkForm;
}